export default "__VITE_ASSET__ClK4ZYQ9__"